import { getInstance } from '@/api/service'
import type { WidgetSettings } from '@/types/dashboard'

/**
 * Saves widget settings to dashboard store
 * @param widgetId - ID of widget
 * @param settings - Settings to save
 */
export const saveWidgetSettings = (widgetId: string, settings: WidgetSettings): void => {
  const api = getInstance()
  api.patchWidget({ settings }, widgetId)
}
